import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';

import { TellentAssistantAnalyticsService } from '@core/tellent-assistant-logic';
import type { AssistantLinkTarget, ListItem } from '@core/tellent-assistant-types';
import { TellentAssistantLinkDirective } from '@core/tellent-assistant-ui';
import { IconComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-assistant-list-card',
  imports: [IconComponent, TellentAssistantLinkDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="content"><ng-content /></div>
    <rt-icon name="open-in-new" class="hover-affordance" />
    @if (linkTarget(); as target) {
      <a
        class="open-link"
        [tellentAssistantLink]="target"
        target="_blank"
        rel="noopener noreferrer"
        [attr.aria-label]="label()"
        (click)="trackClick()"
      ></a>
    } @else if (url(); as href) {
      <a
        class="open-link"
        [href]="href"
        target="_blank"
        rel="noopener noreferrer"
        [attr.aria-label]="label()"
        (click)="trackClick()"
      ></a>
    }
  `,
  styleUrl: './list-card.component.less',
  host: {
    '[class.interactive]': '!!linkTarget() || !!url()',
  },
})
export class ListCardComponent {
  private readonly analytics = inject(TellentAssistantAnalyticsService);

  /** Structured in-app destination; activation can be taken over by a host-provided opener. */
  public readonly linkTarget = input<AssistantLinkTarget | null>(null);
  /** Raw external URL (sources); the panel's delegated listener hands it to the host opener. */
  public readonly url = input<string | null>(null);
  public readonly label = input<string | null>(null);
  public readonly widgetType = input<ListItem['kind'] | null>(null);

  protected trackClick(): void {
    const widgetType = this.widgetType();
    if (widgetType) {
      this.analytics.widgetCardClicked(widgetType);
    }
  }
}
